'use strict';

/* globals Modernizr */
const _ = require('lodash');

const SetPasswordFormController = function ($rootScope, $scope, $stateParams, sbAuth) {

  const vm = this;
  vm.buttonText = 'Set password and log in';
  vm.cloudServicesAgreementUrl = $rootScope.CONST.cloud_services_agreement_url;
  vm.currentView = '';
  vm.error = '';
  vm.inputs = ['password', 'confirmPassword'];
  vm.isTouch = typeof Modernizr !== 'undefined' && Modernizr.touch;
  vm.menuActive = false;
  vm.showDialog = false;
  vm.text = 'This link has expired. Ask your organization administrator to send you a new invitation.';
  vm.data = {
    confirmPassword: '',
    origin: 'core',
    password: '',
    resetToken: $stateParams.reset || $stateParams.invite,
    verifyToken: $stateParams.verify
  };

  vm.loadingSendEmail = false;

  vm.login = _.debounce(() => {

    vm.buttonText = 'Loading...';

    const onError = (res) => {

      vm.buttonText = 'Set password and log in';
      vm.error = res.data.error;
    };
    sbAuth.resetPassword(vm.data, null, onError);
  }, 50);

  vm.toggleMenu = () => {

    vm.menuActive = !vm.menuActive;
  };
};

module.exports = SetPasswordFormController;



// WEBPACK FOOTER //
// ./src/app/login/setPasswordForm/SetPasswordFormController.js